import SearchInput from './SearchInput';

export default SearchInput;



// WEBPACK FOOTER //
// ./src/shared/components/SearchInput/index.js